import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-show-warning',
  templateUrl: './show-warning.component.html',
  styleUrls: ['./show-warning.component.scss'],
})
export class ShowWarningComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
